import { render, staticRenderFns } from "./MisStudentApplicationForm.vue?vue&type=template&id=94877f04"
import script from "./MisStudentApplicationForm.vue?vue&type=script&lang=js"
export * from "./MisStudentApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./MisStudentApplicationForm.vue?vue&type=style&index=0&id=94877f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports